// context/DialogContext.tsx
import React, { createContext, useContext, useState } from 'react';

const DialogContext = createContext(null);

export function DialogProvider({ children }) {
  const [dialogState, setDialogState] = useState({
    open: false,
    content: null,
  });

  const openDialog = (content) => {
    setDialogState({ open: true, content });
  };

  const closeDialog = () => {
    setDialogState({ open: false, content: null });
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      {dialogState.open && (
        <Dialog onClose={closeDialog}>{dialogState.content}</Dialog>
      )}
    </DialogContext.Provider>
  );
}

export function useDialog() {
  return useContext(DialogContext);
}

// Dialog renders its children as passed content
function Dialog({ children, onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(35,41,53,0.9)',
        zIndex: 999999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '8px',
          maxWidth: 600,
          maxHeight: '90vh',
          overflow: 'auto',
          height: 750,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
